"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Box = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Box"));
var _Badge2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Badge"));
var _Separator3 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Separator"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _SidePanelButtonLink = _interopRequireDefault(require("../SidePanelButtonLink"));
var _context = require("../../../../services/auth/context");
var _context2 = require("../../../../services/brand/context");
var events = _interopRequireWildcard(require("../../consts/events"));
var _context3 = require("../../../../services/log/context");
var _useGetUser = _interopRequireDefault(require("../../components/useGetUser"));
var _PromoCode = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/PromoCode"));
var _context4 = require("../../../../services/intl/context");
var _context5 = require("../../services/context");
var _jsxRuntime = require("react/jsx-runtime");
var _FormattedMessage, _Separator, _FormattedMessage2, _FormattedMessage3, _FormattedMessage4, _FormattedMessage5, _Badge, _FormattedMessage6, _Separator2, _FormattedMessage7;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const LoggedPanelLinks = ({
  children
}) => {
  var _user$unreadMessages, _user$referFriend$num, _user$referFriend;
  const user = (0, _useGetUser.default)();
  const {
    onSignOut
  } = (0, _context.useAuth)();
  const {
    isFareLocksLinkShown,
    isReferAFriendShown
  } = (0, _context5.useNavConfig)();
  const {
    log
  } = (0, _context3.useLog)();
  const intl = (0, _reactIntl.useIntl)();
  const {
    language
  } = (0, _context4.useIntl)();
  const {
    company_name: companyName
  } = (0, _context2.useBrand)();
  const unreadMessages = (_user$unreadMessages = user === null || user === void 0 ? void 0 : user.unreadMessages) !== null && _user$unreadMessages !== void 0 ? _user$unreadMessages : 0;
  const validPromoCodes = (_user$referFriend$num = user === null || user === void 0 ? void 0 : (_user$referFriend = user.referFriend) === null || _user$referFriend === void 0 ? void 0 : _user$referFriend.numberOfValidPromoCodes) !== null && _user$referFriend$num !== void 0 ? _user$referFriend$num : 0;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
      direction: "row",
      justify: "between",
      align: "center",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelButtonLink.default, {
        href: `/${language.id}/user/inbox`,
        ariaControls: intl.formatMessage({
          id: "account_v2.inbox.heading.title"
        }),
        onClick: () => log(events.VISIT_INBOX, {}),
        children: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "account_v2.inbox.heading.title"
        }))
      }), unreadMessages > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Badge2.default, {
        dataTest: "TopNav-UnreadMessagesBadge",
        type: "critical",
        children: unreadMessages
      })]
    }), _Separator || (_Separator = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Separator3.default, {})), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelButtonLink.default, {
        href: `/${language.id}/user?tab=trips`,
        ariaControls: intl.formatMessage({
          id: "navbar.account.my_trips"
        }),
        onClick: () => log(events.VISIT_MY_TRIPS, {}),
        children: _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "navbar.account.my_trips"
        }))
      })
    }), isFareLocksLinkShown && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelButtonLink.default, {
        href: `/${language.id}/user?tab=locked-prices`,
        ariaControls: intl.formatMessage({
          id: "navbar.account.locked_prices"
        }),
        onClick: () => log(events.VISIT_FARE_LOCKS, {}),
        children: _FormattedMessage3 || (_FormattedMessage3 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "navbar.account.locked_prices"
        }))
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelButtonLink.default, {
        href: `/${language.id}/user?tab=price-alerts`,
        ariaControls: intl.formatMessage({
          id: "navbar.account.price_alerts"
        }),
        onClick: () => log(events.VISIT_PRICE_ALERTS, {}),
        children: _FormattedMessage4 || (_FormattedMessage4 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "navbar.account.price_alerts"
        }))
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelButtonLink.default, {
        href: `/${language.id}/user?tab=credit`,
        ariaControls: intl.formatMessage({
          id: "navbar.account.kiwi_credit"
        }, {
          companyName
        }),
        onClick: () => log(events.VISIT_KIWICOM_CREDITS, {}),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "navbar.account.kiwi_credit",
          values: {
            companyName
          }
        })
      })
    }), isReferAFriendShown && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      display: "flex",
      align: "center",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelButtonLink.default, {
        href: `/${language.id}/user?tab=refer-friend`,
        ariaControls: intl.formatMessage({
          id: "account_v2.components.refer_friend"
        }),
        onClick: () => log(events.VISIT_REFER_FRIEND, {}),
        children: _FormattedMessage5 || (_FormattedMessage5 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "account_v2.components.refer_friend"
        }))
      }), validPromoCodes > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        display: "inline",
        padding: {
          left: "XLarge"
        },
        children: _Badge || (_Badge = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Badge2.default, {
          dataTest: "TopNav-PromoCode",
          type: "infoSubtle",
          icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PromoCode.default, {
            size: "small"
          })
        }))
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelButtonLink.default, {
        href: `/${language.id}/user?tab=preferences`,
        ariaControls: intl.formatMessage({
          id: "navbar.account.preferences"
        }),
        onClick: () => log(events.VISIT_PREFERENCES, {}),
        children: _FormattedMessage6 || (_FormattedMessage6 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "navbar.account.preferences"
        }))
      })
    }), _Separator2 || (_Separator2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Separator3.default, {})), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelButtonLink.default, {
        onClick: onSignOut,
        ariaControls: intl.formatMessage({
          id: "navbar.header.sign_out"
        }),
        children: _FormattedMessage7 || (_FormattedMessage7 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "navbar.header.sign_out"
        }))
      })
    }), children]
  });
};
var _default = LoggedPanelLinks;
exports.default = _default;